<div class="tickets-container">
  <h1>Chamados</h1>

  <div class="status-filters" [formGroup]="statusForm">
    <mat-checkbox formControlName="open">Aberto</mat-checkbox>
    <mat-checkbox formControlName="inProgress">Em andamento</mat-checkbox>
    <mat-checkbox formControlName="closed">Fechado</mat-checkbox>
  </div>

  <div class="tickets-list">
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (!isLoading && (!tickets || tickets.length === 0)) {
      <div class="no-tickets">
        Nenhum ticket
      </div>
    }

    @if (!isLoading && tickets && tickets.length > 0) {
      <div>
        @for (ticket of tickets; track ticket) {
          <app-ticket-summary-tile [ticket]="ticket"></app-ticket-summary-tile>
        }
      </div>
    }
  </div>

  @if (!isLoading && tickets && tickets.length > 0) {
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  }

  <div class="actions">
    <button mat-raised-button color="accent" (click)="navigateToCreateTicket()">Criar</button>
  </div>
</div>
